import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName, IconType } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseBadgeElement, toBadgeProps } from '../common';
var ChecklistProgressElement = function ChecklistProgressElement(props) {
  var _context$checklistPro;
  var context = useFlexibleUiContext();
  var data = context ? toBadgeProps((_context$checklistPro = context.checklistProgress) === null || _context$checklistPro === void 0 ? void 0 : _context$checklistPro.toString()) : null;
  return data ? /*#__PURE__*/React.createElement(BaseBadgeElement, _extends({
    icon: IconType.CheckItem
  }, data, props, {
    name: ElementName.ChecklistProgress
  })) : null;
};
export default ChecklistProgressElement;